module.exports = {
  "id": 29,
  "name": "Shoulder Taps",
  "categories": [
    "strength",
    "core",
    "balance"
  ],
  "sports": [
    "soccer",
    "basketball",
    "football",
    "baseball",
    "tennis",
    "volleyball"
  ],
  "difficulty": "intermediate",
  "skill": "Core",
  "points": 10,
  "instructions": "Shoulder Taps make your arms and core super strong! Get in a push-up position, then tap your right shoulder with your left hand, then your left shoulder with your right hand!",
  "timedInstructions": [
    {
      "time": 2,
      "text": "Ready to tap your shoulders?"
    },
    {
      "time": 4,
      "text": "Here we go!"
    },
    {
      "time": 5,
      "text": "3, 2, 1"
    },
    {
      "time": 8,
      "text": "Tap right shoulder"
    },
    {
      "time": 10,
      "text": "Tap left shoulder"
    },
    {
      "time": 12,
      "text": "Tap right shoulder"
    },
    {
      "time": 14,
      "text": "Tap left shoulder"
    },
    {
      "time": 16,
      "text": "Keep going"
    },
    {
      "time": 18,
      "text": "Great job! Take a break"
    },
    {
      "time": 20,
      "text": "Breathe in and out"
    },
    {
      "time": 22,
      "text": "Ready for round two!"
    },
    {
      "time": 24,
      "text": "3, 2, 1"
    },
    {
      "time": 27,
      "text": "Tap right shoulder"
    },
    {
      "time": 29,
      "text": "Tap left shoulder"
    },
    {
      "time": 31,
      "text": "Tap right shoulder"
    },
    {
      "time": 33,
      "text": "Tap left shoulder"
    },
    {
      "time": 35,
      "text": "Keep going"
    },
    {
      "time": 37,
      "text": "Great job! Take another break"
    },
    {
      "time": 39,
      "text": "Breathe in and out"
    },
    {
      "time": 41,
      "text": "Ready for round three!"
    },
    {
      "time": 43,
      "text": "3, 2, 1"
    },
    {
      "time": 46,
      "text": "Tap right shoulder"
    },
    {
      "time": 48,
      "text": "Tap left shoulder"
    },
    {
      "time": 50,
      "text": "Tap right shoulder"
    },
    {
      "time": 52,
      "text": "Tap left shoulder"
    },
    {
      "time": 54,
      "text": "Keep going"
    },
    {
      "time": 56,
      "text": "Great job! Take a final break"
    },
    {
      "time": 58,
      "text": "Breathe in and out"
    },
    {
      "time": 60,
      "text": "Ready for the final round!"
    },
    {
      "time": 62,
      "text": "3, 2, 1"
    },
    {
      "time": 65,
      "text": "Tap right shoulder"
    },
    {
      "time": 67,
      "text": "Tap left shoulder"
    },
    {
      "time": 69,
      "text": "Tap right shoulder"
    },
    {
      "time": 71,
      "text": "Tap left shoulder"
    },
    {
      "time": 73,
      "text": "Keep going"
    },
    {
      "time": 75,
      "text": "Awesome job, you're a shoulder master!"
    }
  ]
};